import { SizeGuide as BaseSizeGuide } from './SizeGuide'
import { Section } from './Section'

export const SizeGuide = Object.assign(BaseSizeGuide, {
  Section,
})
